import React, { useState } from "react";
import Header from "./Comp/Header/header";
import Spaces from "./Comp/Spaces";
import Sidebar from "./Comp/Sidebar";
import { AuthenticateDocument } from "./Utils/AuthenticateDocument";
import './App.css';
import { ChatBox } from "./Comp/ChatBox/ChatBox";
import Loader from "./Comp/SkeletonLoader/skeletonLoader";

function App() {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [contentLoading, setContentLoading] = useState(true);
  if (isAuthenticating) {
    return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
  }

  return (
    <div>
      {contentLoading && <Loader />}
      {!contentLoading && <Header />}
      <div className="content-container">
        {!contentLoading &&
          <div>
            <Sidebar />
          </div>
        }
        <div className="spaces-wrapper">
          <Spaces
            contentLoading={contentLoading}
            setContentLoading={setContentLoading}
          />
        </div>
      </div>
      {!contentLoading && <ChatBox />}
    </div>
  );
}

export default App;
